exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".level.app-levelbar{margin:5px 0 12px}.level.app-levelbar .v-breadcrumbs{padding:5px 0 0 0}.level.app-levelbar .v-breadcrumbs li.v-breadcrumbs__divider{padding:0 6px}", ""]);
